export default {
    name: 'speakers-mobile',
    props: {
        item: {}
    }
}
